import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {UpdateArchivableParams} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {assertAndContinue} from 'Asserts';
import {ExperimentMethodPlanREST} from 'studies/typed/process-development/Types';
import {patchJSONPromise, postJSONPromise} from 'util/Net';

export type SourcePMEIIdsByTemplatePMDVIdREST = Record<string, Array<string>>;
export interface ExperimentConditionREST {
  replicateInfos: Array<{
    replicateNumber: number;
    // Used to add experiment method instance associations for the new condition
    sourcePMEIIdsByTemplatePMDVId?: SourcePMEIIdsByTemplatePMDVIdREST;
  }>;
  methodPlans: Array<ExperimentMethodPlanREST>;
  name: string;
  description?: string;
}

// Keep in sync with benchling/procedures/network/rest/procedure_run_rest_specs.py
export interface CreateProcedureRunParams {
  name: string;
  folderId: string;
  templateProcedureFlowchartVersionId: string;
  organizationId: string;
  experimentConditions: Array<ExperimentConditionREST>;
  studyId?: string;
}

export interface CreateProcedureRunResponse {
  createdId: string;
}

export async function createProcedureRun(
  procedureRun: CreateProcedureRunParams
): Promise<CreateProcedureRunResponse> {
  const creates = [procedureRun];
  const {createdIds} = await postJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.PROCEDURE_RUN),
    data: {creates},
  });
  assertAndContinue(createdIds.length === 1, 'Expected exactly one procedure run created');
  return {createdId: createdIds[0]};
}

export interface UpdateProcedureRunParams extends UpdateArchivableParams {
  id: string;
  name?: string;
  newConditions: Array<ExperimentConditionREST>;
}

export interface UpdateProcedureRunResponse {
  updatedIds: Array<string>;
}

export function updateProcedureRun(
  procedureRun: UpdateProcedureRunParams
): Promise<UpdateProcedureRunResponse> {
  const updates = [procedureRun];
  return patchJSONPromise({url: getApiBaseForObjectType(DomainGraphType.PROCEDURE_RUN), data: {updates}});
}
